import React from 'react';
import {
  SKETCHPLAN_DISPLAY_CURRENCIES,
  CURRENCY_LABEL,
  CURRENCY_SHORT_LABEL,
  CURRENCY_ACCESSIBLE_LABEL,
  type SketchplanCurrency,
} from '@rehub/pricing';
import { selectSketchplanCurrency } from './useSketchplanCurrency';

interface CurrencyToggleProps {
  value: SketchplanCurrency;
  onChange: (currency: SketchplanCurrency) => void;
  className?: string;
}

/** Compact UK £ | EU € | US $ toggle. EUR is display-only until checkout is approved. */
const CurrencyToggle: React.FC<CurrencyToggleProps> = ({ value, onChange, className = '' }) => (
  <div
    role="group"
    aria-label="Currency"
    className={`flex flex-col items-end gap-1 ${className}`}
  >
    <span className="text-[10px] font-medium uppercase tracking-wide text-slate-500">Currency</span>
    <div className="flex bg-slate-800/60 rounded-full p-1 gap-0.5 border border-slate-700/50">
      {SKETCHPLAN_DISPLAY_CURRENCIES.map((c) => (
        <button
          key={c}
          type="button"
          aria-pressed={value === c}
          aria-label={CURRENCY_ACCESSIBLE_LABEL[c]}
          title={CURRENCY_ACCESSIBLE_LABEL[c]}
          onClick={() => {
            selectSketchplanCurrency(c);
            onChange(c);
          }}
          className={`rounded-full px-2.5 py-1.5 text-xs font-semibold transition-all duration-200 sm:px-3 ${
            value === c ? 'bg-[#40E0D0] text-slate-900' : 'text-slate-400 hover:text-slate-200'
          }`}
        >
          <span className="sm:hidden">{CURRENCY_SHORT_LABEL[c]}</span>
          <span className="hidden sm:inline">{CURRENCY_LABEL[c]}</span>
        </button>
      ))}
    </div>
  </div>
);

export default CurrencyToggle;
